import { render, staticRenderFns } from "./XMenuItem.vue?vue&type=template&id=b0bc64c4&scoped=true"
import script from "./XMenuItem.vue?vue&type=script&lang=js"
export * from "./XMenuItem.vue?vue&type=script&lang=js"
import style0 from "./XMenuItem.vue?vue&type=style&index=0&id=b0bc64c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_50f6069bc14464b8bd79aa1c8f71d64f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bc64c4",
  null
  
)

export default component.exports